




































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import {
  getSubDDL, copyArray, toDefaultStr, toDefaultInt, tryToStr, tryToInt, jsonStoreage
} from '@/configs/functions'
import { enFirstType } from '@/configs/enums'
import {
  getList, backData, removeData, CruiseMakeupData, emptyCruiseMakeup
} from '@/api/heritageCruise/cruiseMakeup'
//import ViewLink from '@/components/viewLink.vue'
import ImageViewer from '@/components/imgViewer.vue'
import CruiseMakeupView from '@/components/heritageCruise/cruiseMakeup/view.vue'
import PageList from '@/components/pageLayout/list.vue'

import {
  PagePermissionState, PermissionData, FailedPermission
} from '@/store/modules/pagePermission'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const PagePermissionModule = namespace('pagePermission')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageList, CruiseMakeupView, ImageViewer
  }
})
export default class CruiseMakeupList extends Vue {
  public showMore: boolean = false
  @PagePermissionModule.Getter
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public pagePath: string = ''
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    let path = ''
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
      path = s.pagePath
    }
    this.btnCtrl = p
    this.pagePath = path
    var cacheQuery = jsonStoreage.getFilter(path)
    if (cacheQuery && cacheQuery != null) {
      this.queryTerm = Object.assign({}, cacheQuery)
      jsonStoreage.removeFilter(path)
    }
    else {
      this.getQueryTerm()
    }
  }
  @UserModule.Getter('userInfo')
  public curUser!: UserData

  public arrStatus: any = []
  //是否有省级用户
  // public provinceAudit: boolean = this.curUser.SysAuth.HasProvinceUser

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public list: any = []
  public levelList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public issueTypeList: DDLItem[] = []
  public issueLevelList: DDLItem[] = []
  public statusList: DDLItem[] = []

  public listLoading: boolean = true
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize
  // 选中项,这里存的是整个行的数据
  public selectedRows: any = []
  // 查询项
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'UpdateDate',
    IsAsc: false,

    LevelId: 0,
    CityId: 0,
    CountyId: 0,
    ClassifyId: 0,
    DateRange: 0,
    StartDate: '',
    EndDate: '',
    Status: 0,
    Keyword: ''
  }
  public lastQuery = Object.assign({}, this.queryTerm)
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'UpdateDate'),
      IsAsc: tryToStr(query['IsAsc']) == 'true',

      LevelId: tryToInt(query['LevelId']),
      CityId: tryToInt(query['CityId']),
      CountyId: tryToInt(query['CountyId']),
      ClassifyId: tryToInt(query['ClassifyId']),
      DateRange: tryToInt(query['DateRange']),
      StartDate: tryToStr(query['StartDate']),
      EndDate: tryToStr(query['EndDate']),
      Status: tryToInt(query['Status']),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  //列表操作按钮配置
  public setTableAction() {
    this.list.forEach((e: any, i: number) => {
      this.setRowAction(e)
    })
  }
  //单行操作按钮配置
  public setRowAction(e: any) {
    //状态：1草稿(不要了) 2退回 3提交
    const btn = this.btnCtrl
    /*
      1省级文物局 2省财政用户
      3市文物局 4市财政用户
      5区县用户
      6评估机构用户 7评估专家
      8文保单位用户 9巡查人员用户
    */
    const userId = this.curUser.Id
    const isSelf = e.NewUserId == userId

    //是否是最高级用户，最高级用户，没有退回功能，可以直接修改和删除自己的记录
    const isTopUser = (this.curUser && this.curUser.SysAuth) ? this.curUser.SysAuth.IsTopUser : false

    // 只要是子级提交的都可以退回
    e.DoBack = btn.HasBack && !isSelf && e.Status == 3
    //最高级用户，或者自己的记录(退回状态)
    e.DoEdit = btn.HasEdit && isSelf && (isTopUser || e.Status < 3)
    e.DoDel = btn.HasDel && isSelf && (isTopUser || e.Status < 3)
  }
  // 设置初始排序,无排序可以删掉
  get tableSort() {
    return {
      prop: this.queryTerm.SortBy,
      order: this.queryTerm.IsAsc ? 'ascending' : 'descending'
    }
  }
  // 多选的时候，用到，返回选中的行，这里存的是数组
  public selectedChange(val: any[]) {
    this.selectedRows = val
  }
  // 点击排序按钮的时候，按新排序查询数据
  public sortChange(col: { [key: string]: string }) {
    const query = this.lastQuery
    const asc = col.order === 'ascending' // descending
    if (query.SortBy !== col.prop || query.IsAsc !== asc) {
      query.SortBy = col.prop
      query.IsAsc = asc
      this.refreshData()
    }
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    const qt = this.queryTerm
    const query = this.lastQuery
    query.Page = qt.Page
    query.PageSize = qt.PageSize
    this.refreshData()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData(this.queryTerm)
  }
  public created() {
    this.getPermission()
    this.fetchSource()
  }
  // 页面加载事件=pageload
  public mounted() {
    this.doSearch()
  }
  @DataSourceModule.Getter('unitLevel')
  public unitLevel!: any
  @DataSourceModule.Getter('unitClassify')
  public unitClassify!: any
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  // 数据项加载
  public fetchSource() {
    var unitLevel = copyArray(this.unitLevel)
    if (unitLevel) {
      this.levelList = unitLevel
    }
    var unitClassify = copyArray(this.unitClassify)
    if (unitClassify) {
      this.classifyList = unitClassify
    }
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
      if (this.queryTerm.CityId > 0) {
        this.cityChange(0)
      }
    }
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.statusList = data.statusList
    }
  }
  public cityChange(reset: number) {
    const qt = this.queryTerm
    this.countyList = [this.defItem]
    if (reset === 1) {
      qt.CountyId = 0
    }
    if (qt.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, qt.CityId)
      if (this.countyList.length == 1) {
        qt.CountyId = this.countyList[0].Key
      }
    }
  }
  // 连接后台api查询
  public fetchData(query: any) {
    this.listLoading = true
    getList(query).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data.Results
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount

        this.queryTerm.PageSize = data.PageSize
        this.queryTerm.Page = query.Page
        this.queryTerm.SortBy = query.SortBy
        this.queryTerm.IsAsc = query.IsAsc
        
        this.lastQuery = Object.assign({}, query)
        jsonStoreage.setFilter(this.pagePath, query)
        this.setTableAction()
      }
      this.listLoading = false
    })
  }
  public refreshData() {
    this.fetchData(this.lastQuery)
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getPermission()
    this.doSearch()
  }

  public doExport() {
    // 克隆参数
    const qt = Object.assign({}, this.lastQuery)
    // exportUserList('用户列表', qt)
  }
  public doAdd() {
    this.$router.push({ path: `/CruiseMakeup/New` }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public doEdit(id: number) {
    this.$router.push({ path: `/CruiseMakeup/Edit/${id}` }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public doBack(id: number) {
    this.$confirm('确定要退回吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        backData(id).then(() => {
          this.$message({ type: 'success', message: '退回成功' })
          this.refreshData()
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
  }
  public doDel(id: number) {
    this.$confirm('确定要删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        removeData(id).then(() => {
          this.$message({ type: 'success', message: '删除成功' })
          this.refreshData()
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
  }
}
